export const anonymousAccessPath = (anonymousAccessId: string) => {
  return `/assets/anonymous-access/${anonymousAccessId}`;
};
